<template>
    <div>
        <div class="px-3 py-3 primary--text fw600 header heebo">{{title}}
            <slot></slot>
        </div>
        <div v-if="!groupBy">
            <div v-for="(item, i) in list" :key="i" @click="select(item)"
                 :class="[{'selected primary--text font-weight-bold': item.id === selected},
                        {'py-2 px-3 body-2 item text-truncate': !large},
                        {'py-3 px-3 item text-truncate': large},
                        ]">
                <span v-if="!hideId">
                    <v-icon v-if="item.inaktiv" small>mdi-delete</v-icon>
                    {{item.id}} - </span>{{item.name}}
                <span v-if="item.addOn" class="blue--text"><v-icon>mdi-alert-decagram</v-icon>{{item.addOn}}</span>
            </div>
        </div>
        <div v-else>
            <div v-for="(group, i) in groups" :key="i">
                <div class="body-2 primary--text px-3 pt-3 pb-2">
                    <span v-if="groupHeader">{{groupHeader(group)}}</span>
                    <span v-else>{{group}}</span>
                </div>
                <div v-for="(item, i) in list" :key="i">
                    <div v-if="item[groupBy]===group" @click="select(item)"
                         :class="[{'selected primary--text font-weight-bold': item.id === selected},
                        {'py-2 px-4 body-2 item text-truncate': !large},
                        {'py-3 px-4 item text-truncate': large},
                        ]">
                        <span v-if="!hideId">{{item.id}} - </span>{{item.name}}
                        <span v-if="item.addOn" class="blue--text font-weight-bold">{{item.addOn}}
                            <v-icon color="blue">mdi-alert-decagram</v-icon>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "selection-list",
        props: ['list', 'title', 'hideId', 'large', 'groupBy', 'groupHeader', 'header2'],
        data: () => ({
            selected: null,
        }),
        computed: {
            ligaTypes(){ return this.$store.state.local.ligaTypes },
            groups(){
                if ( !this.groupBy ) {
                    return [];
                } else {
                    let groups = [];
                    this.list.forEach( (item) => {
                        if ( !groups.includes(item[this.groupBy]) ) {
                            groups.push(item[this.groupBy]);
                        }
                    });
                    groups = groups.map( group => ({
                        groupValue: group, sort: this.ligaTypes.find(type => type.value === group)?.sort??0
                    }))
                    groups.sort((a, b) => a.sort > b.sort ? 1 : -1);
                    return groups.map(group => group.groupValue);
                }
            }
        },
        methods: {
            select(item){
                this.selected = item.id;
                this.$emit('selected', item);
            },
            setItemFromQuery(){
                if ( this.$route.query.itemId !== '' ) {
                    let item = this.getItemById();
                    if ( item ) { this.select(item); }
                }
            },
            getItemById(){
                if ( this.$route.query.itemId !== '' ) {
                    return this.list.find(item => item.id == this.$route.query.itemId );
                } else {
                    return null;
                }
            }
        },
        watch: {
            '$route.query.id'(){
                this.selected = null;
            },
            list(){
                this.setItemFromQuery();
            },
            '$route.query.itemId'(){
                // special treatment, not for mitgliederverwaltung but for ergebnisdienst (liga)
                if ( !this.$route.query.itemId && !this.$route.query.id ) {
                    this.selected = null;
                } else if ( this.$route.query.itemId && !this.selected) {
                    this.selected = this.$route.query.itemId;
                }
            },

        }
    }
</script>

<style scoped>
    .selected { background-color: #f2f2f2 }
    .item:hover { background-color: #f2f2f2; cursor: default }
    .header {border-bottom: solid 1px lightgrey; }

</style>